import {GPTextureRenderer} from "./gp-texturerenderer.js";
import {GPProjectView} from "./gp-projectview";

export class GPTexture {

    constructor(gtt) {

        this.typeName = "GPTexture"
        this.id = parseInt(gtt['-id']);
        this.name = gtt['-nm'];
        this.image = gtt['-img'];
        this.package = gtt['package'];
        this.premium = gtt['-pr'];
        this.fullscreen = gtt['-fs'];

        this.thumbSrc = this.staticGetPathForThumb();
        this.enabled = GPSettings.products[this.package + "_database"].active;
        this.visible = true;

        if (this.id === 9000) {
            this.noHorizonOffset = true;
            this.algorithm = "reflection";
        } 
        
    }

    staticGetPathForImage () {
        return GPSettings.texturesAddr(this, false) + 'drawings/' + this.image + '.jpg';
    }

    staticGetPathForThumb () {
        return GPSettings.texturesAddr(this, true) + 'thumbs/' + this.image + '.jpg';
    }

    /**
     *
     * @param {number} rotation
     * @param {number} zoom
     * @return {Promise<Canvas>}
     */

    getTextureCanvas (rotation, zoom) {
        let that = this;
        
        return new Promise(function(resolve, reject) {
            try {
                if (that.algorithm === "reflection") {
                    that.prepareDisplacement().then(
                        that.prepareReflection).then(
                        function (reflectiveCanvas) {
                            resolve(reflectiveCanvas);
                        });
                    return;
                }
                if (!that.fullscreen) {
                    GPTextureRenderer.renderTextureToPNG(that.staticGetPathForImage(), GP.project.designWidth, rotation, zoom)
                        .then(GPTextureRenderer.getImageContext)
                        .then((c) => {
                            resolve(c.canvas)
                        }).catch((e) => {reject(e)});
                    return;
                }
                if (that.fullscreen) {
                    var img = new Image();
                    img.onload = function () {
                        //Scale loaded image to the size that covers original project image
                        var oc = document.createElement('canvas'),
                            octx = oc.getContext('2d');

                        //we're scaling to X, because that scaling to Y would be needed only on very portrait oriented images (with high horizon)
                        //TODO: it should also bring into account scale (GP.project.designWidth)
                        var scale = GP.project.sizeX / img.width;
                        oc.width = img.width * scale;
                        oc.height = img.height * scale;
                        octx.drawImage(img, 0, 0, oc.width, oc.height);
                        resolve(oc);
                    };
                    img.src = that.staticGetPathForImage();

                }
            } catch (e) {
                reject(e);
            }
        })
    }
    
    prepareDisplacement () {
        return new Promise(function(resolve, reject) {
            var img = new Image;
            img.onload = function(){
                var can = document.createElement('canvas');
                var ctx = can.getContext('2d');

                can.width  = GP.project.sizeX;
                can.height = GP.project.sizeY;

                ctx.scale(GP.project.sizeX/img.width, GP.project.sizyY/img.height);
                ctx.translate(0, (0.8-GP.project.horizonPos)*GP.project.sizeY);
                ctx.drawImage(img, 0,0, GP.project.sizeX, GP.project.sizeY);

                var arr = ctx.getImageData(0, 0, can.width, can.height);
                
                resolve(arr.data);
            };
            img.src = "img/water.jpg";
        });
    }
    
    prepareReflection (displacementData) {
        return new Promise(function(resolve, reject) {
            GPProjectView.reflectView();
            var jpgData = GP.generateJPGImage(GP.project.sizeX, GP.project.sizeY);
            GPProjectView.unreflectView();

            var img = new Image;
            img.onload = function(){
                var reflectiveCanvas = document.createElement('canvas');
                var ctx = reflectiveCanvas.getContext('2d');

                reflectiveCanvas.width  = img.width;
                reflectiveCanvas.height = img.height;

                ctx.drawImage(img, 0,0);

                //

                var newImage = ctx.createImageData(reflectiveCanvas.width, reflectiveCanvas.height);
                var arr = ctx.getImageData(0, 0, reflectiveCanvas.width, reflectiveCanvas.height);
                var pixels = arr.data;


                for(var x = 0; x < reflectiveCanvas.width; x++){
                    for(var y = 0; y < reflectiveCanvas.height; y++){
                        var di = (y * reflectiveCanvas.width + x) * 4;
                        var sx = x - Math.round((displacementData[di+2]-140)*0.2);
                        var sy = y - Math.round((displacementData[di+1]-130)*1);

                        if (sy<0) sy = 0;
                        if (sy>reflectiveCanvas.height) sy = 2* reflectiveCanvas.height - sy;
                        if (sx<0) sx = 0;
                        if (sx>reflectiveCanvas.width) sx = 2* reflectiveCanvas.width - sx;

                        var i = (y * reflectiveCanvas.width + x) * 4;
                        var si = (sy * reflectiveCanvas.width + sx) * 4;

                        var horizonDist = (y - (1 - GP.project.horizonPos ) * reflectiveCanvas.height)/reflectiveCanvas.height;
                        var refl = (0.5-horizonDist)*0.5+0.5;

                        newImage.data[i] = Math.round(pixels[si]*refl);
                        newImage.data[i + 1] = Math.round(pixels[si + 1]*refl);
                        newImage.data[i + 2] = Math.round(pixels[si + 2]*refl);
                        newImage.data[i + 3] = 255;
                    }
                }

                ctx.clearRect(0, 0, reflectiveCanvas.width, reflectiveCanvas.height);
                ctx.putImageData(newImage, 0, 0);  
                resolve(reflectiveCanvas);
            };
            img.src = jpgData;        
        });
    }

}

